import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const AvatarImage = styled.img`
  border-radius: 50%;
  height: 3.125rem;
  width: 3.125rem;
  ${props => props.size === 'small' && css`
    height: 2.25rem;
    width: 2.25rem;
  `}
  ${props => props.envySidebar && css`
    border: 3px solid rgba(255, 255, 255, 0.2);
    height: 2.625rem;
    width: 2.625rem;
  `}
`;

export const AvatarDiv = styled.div`
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 2.25rem;
  justify-content: center;
  width: 2.25rem;

  ${props => props.color && css`
    background-color: var(--${props.color});
    color: var(--white);
    span {
      padding: 0.375rem 0 0 0;
    }
  `}
  ${props => props.color === 'gray' && css`
    background-color: rgba(var(--purple-gray-rgb), 0.1);
    color: rgba(var(--purple-gray-rgb), 0.5);
  `}
  ${props => props.size === 'medium' && css`
    font-size: var(--step-up-2);
    height: 3.125rem;
    width: 3.125rem;
  `}
  ${props => props.envySidebar && css`
    background-clip: content-box;
    background-color: var(--blue-gray);
    border: 3px solid rgba(255, 255, 255, 0.2);
    height: 2.625rem;
    width: 2.625rem;
  `}
`;

export const AvatarGroup = styled.div`
  display: grid;
  grid-gap: 1.25rem;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;

  h3 {
    grid-column: 1 / span 3;
    margin-bottom: -2em;
    margin-top: 0;
  }

  @media (min-width: 56em) {
    max-width: 25rem;
  }
  @supports not (display: grid) {
    display: flex;
    flex-wrap: wrap;
    max-width: 40rem;
    width: 100%;
  }
`;

const AvatarCheckboxInput = styled.input`
  display: none;
`;

const AvatarCheckboxSelect = styled.img`
  cursor: pointer;
  opacity: 0.5;
  width: 100%;
  &:hover {
    opacity: 0.75;
  }

  ${props => props.selected && css`
    border: 3px solid var(--purple);
    box-sizing: content-box;
    margin: -3px;
    opacity: 1;
    &:hover {
      opacity: 1;
    }
  `}

  @supports not (display: grid) {
    padding: 0 1rem 1rem 0;
    ${props => props.selected && css`
      box-sizing: border-box;
      margin-right: 0.5rem;
      margin: 0;
      padding: 0;
      width: 92%;
    `}
  }
`;

const Avatar = ({ alt, color, envySidebar, initials, selected, size, src }) => {
  if (src) {
    let optimizedSrc = src.substr(0, src.lastIndexOf('.'));
    optimizedSrc += (size === 'small') ? '-72.png' : '-100.png';
    return (
      <AvatarImage
        alt={alt}
        src={optimizedSrc}
        size={size}
        envySidebar={envySidebar}
        selected={selected}
      />
    );
  }
  return (
    <AvatarDiv
      size={size}
      envySidebar={envySidebar}
      color={color}
      selected={selected}
    >
      <span>{initials}</span>
    </AvatarDiv>
  );
};

export function AvatarCheckbox(props) {
  const {
    alt,
    name,
    value,
    src,
    checked,
    onChange,
    disabled,
  } = props;

  if (src) {
    return (
      <React.Fragment>
        <AvatarCheckboxInput
          type="checkbox"
          name={name}
          value={value}
          id={`person-${props.value}`}
          disabled={disabled}
          checked={checked}
          onChange={onChange}
        />
        <label
          htmlFor={`person-${props.value}`}
        >
          <AvatarCheckboxSelect
            alt={alt}
            src={src}
            selected={checked}
          />
        </label>
      </React.Fragment>
    );
  }
  return (
    <label htmlFor={`person-${props.value}`}>
      <input
        checked={checked}
        disabled={disabled}
        id={`person-${props.value}`}
        name={name}
        onChange={onChange}
        type="checkbox"
        value={value}
      />
      {alt}
    </label>
  );
}


// Prop Types

Avatar.defaultProps = {
  color: 'gray',
  initials: 'CD',
  envySidebar: false,
  selected: false,
  size: 'small',
  src: '',
};

Avatar.propTypes = {
  color: PropTypes.oneOf(['blue', 'gray']),
  initials: PropTypes.string,
  envySidebar: PropTypes.bool,
  selected: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  src: PropTypes.string,
};

AvatarImage.defaultProps = {
  color: 'gray',
  envySidebar: false,
  name: 'Client Dashboard',
  selected: false,
  size: 'medium',
  src: '',
};

AvatarImage.propTypes = {
  color: PropTypes.oneOf(['blue', 'gray']),
  envySidebar: PropTypes.bool,
  name: PropTypes.string,
  selected: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  src: PropTypes.string,
};

AvatarCheckboxSelect.defaultProps = {
  alt: '',
  selected: false,
  src: '',
};

AvatarCheckboxSelect.propTypes = {
  alt: PropTypes.string,
  selected: PropTypes.bool,
  src: PropTypes.string,
};

AvatarCheckboxInput.defaultProps = {
  checked: false,
  name: 'Client Dashboard',
};

AvatarCheckboxInput.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar.js